import React, { useEffect, useState } from 'react';
import { useFrame, useLoader } from '@react-three/fiber'
/* @ts-ignore */
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { CuboidCollider, RigidBody } from '@react-three/rapier';
import { useGameController } from './hooks/useGameController.ts';
import { Outlines } from '@react-three/drei';
import { applyRealisticMaterials, applyNaturalMaterials, applyMetalMaterials } from './utils/materialUtils.ts';

const models = {
    money: 'data/models/money.gltf',
    snack: 'data/models/Snack/snack.gltf',
    briefcase: 'data/models/briefcase.gltf',
    enveloppe: 'data/models/enveloppe.gltf',
    book: 'data/models/book.gltf',
    soda: 'data/models/soda.gltf',
    hotdog: 'data/models/hot_dog.gltf',
    rock: 'data/models/rock.gltf',
    twig: 'data/models/twig.gltf',
    apple: 'data/models/apple.gltf',
}

export default function Item({id, uid, position, scale, initialRotation, data, item}) {
    const gameController = useGameController();
    const [active, setActive] = useState(true);
    const { scene, nodes, materials} = useLoader(GLTFLoader, models[id]);
    const [rotation, setRotation] = useState([0,0,0]);

    useFrame(() => {
        if(active && gameController.settings.items.renderType != 'physics') {
            setRotation([rotation[0], rotation[1] + 0.01, rotation[2]]);
        }
    });

    useEffect(() => {
        // Apply realistic materials based on item type
        if (scene) {
            if (id === 'apple' || id === 'twig' || id === 'rock') {
                applyNaturalMaterials(scene);
            } else if (id === 'money' || id === 'briefcase') {
                applyMetalMaterials(scene);
            } else {
                applyRealisticMaterials(scene);
            }
        }
    }, [scene, id]);

    function destroy(){
        //setActive(false);
        onIntersectionExit();
    }

    function onInteraction(){
        gameController.clearPlayerHint();
        gameController.removeEventHandler(["player:interacted"], uid, onInteraction);
        gameController.takeItem(uid, item);
        //destroy();
        return true;
    }

    function onIntersectionEnter(event){
        if(!event.rigidBody.userData) return;
        console.log("Intersection with item", event);
        gameController.setPlayerHint("(E) Take")
        gameController.addEventHandler(["player:interacted"], uid, onInteraction, 1);
    }

    function onIntersectionExit(event){

        if(!event.rigidBody.userData) return;
        gameController.clearPlayerHint();
        gameController.removeEventHandler(["player:interacted"], uid, onInteraction);
    }

    function renderPhysicalItem(){
        if(gameController.settings.items.renderType == 'physics') {
            return (
                <RigidBody type="dynamic" colliders="hull" gravityScale={1} linearDamping={4} angularDamping={4}>

    <CuboidCollider 
        args={[1, 1, 1]} 
        sensor
        onIntersectionEnter={onIntersectionEnter}
        onIntersectionExit={onIntersectionExit}
    />

    <mesh 
        scale={scale} 
        geometry={scene.children[0].geometry} 
        rotation={initialRotation} 
        material={Object.values(materials)[0]}
    >
        <Outlines thickness={2.5} color="white" />
    </mesh>
</RigidBody>
            )
        } else {
            return (
                <CuboidCollider 
                        args={[0.2, 0.2, 0.2]} 
                        sensor 
                        onIntersectionEnter={onIntersectionEnter}
                        onIntersectionExit={onIntersectionExit}
                        >
                <mesh scale={scale} geometry={scene.children[0].geometry} rotation={initialRotation} material={Object.values(materials)[0]}>
                    <Outlines  thickness={2.5} color="white" />
                </mesh>
                </CuboidCollider>
            )
        }
    }
    
    return active && (
        <group rotation={rotation} position={position}>
            {renderPhysicalItem()}
        </group>
    );
  
};